class AvailabilityModalController {
  constructor(
    $scope,
    $uibModalInstance,
    $q,
    date
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$q = $q;
    this._date = date;

    this._errors = [];

    //this._init();
  }

  get date() {
    return this._date;
  }

  setAvailable() {
    this.$uibModalInstance.close(true);
  }
  setUnavailable() {
    this.$uibModalInstance.close(false);
  }
  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default AvailabilityModalController;

